module.exports = __webpack_public_path__ + "static/media/typescript.947cdc18.png";